import { CircularProgress } from '@mui/material'
import style from "./styles.module.scss"
export const SpinLoading = () => {
  return (
    <div className={style.container}>
        <CircularProgress sx={{color: "black"}} />
    </div>
  )
}
